import { render, staticRenderFns } from "./OutOfInventoryPlateInfo.vue?vue&type=template&id=6076e531&"
import script from "./OutOfInventoryPlateInfo.vue?vue&type=script&lang=js&"
export * from "./OutOfInventoryPlateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports